import { ensureNoUndefinedProperties } from '@/Shared/Helper/EnsureNoUndefinedProperties'
import UserID from '@/App/User/Entity/UserID'
import type {
    UserData,
    UserProfilePictureFile,
} from '@/Shared/AutoGenerated/Main'

export default class User {
    constructor(
        public readonly id: UserID,
        public readonly firstName: string,
        public readonly lastName: string | null,
        public readonly email: string,
        public readonly profilePicture: UserProfilePictureFile | null,
        public readonly admin: boolean,
    ) {
        ensureNoUndefinedProperties(this)
    }

    getFullName(): string {
        return `${this.firstName} ${this.lastName ?? ''}`.trim()
    }

    getProfilePictureUrlWithFallback(): string {
        return this.profilePicture?.url ?? '/static/images/profile.png'
    }

    // ------------------------
    // Hydration
    // ------------------------

    static hydrateSingleOrNull(entityData: UserData | null): User | null {
        if (!entityData) {
            return null
        }

        return this.hydrateSingle(entityData)
    }

    static hydrateSingle(entityData: UserData): User {
        return new User(
            new UserID(entityData.id),
            entityData.firstName,
            entityData.lastName,
            entityData.email,
            entityData.profilePicture,
            entityData.admin,
        )
    }

    static hydrateMultiple(entitiesData: UserData[]): User[] {
        return entitiesData.map((entityData) => this.hydrateSingle(entityData))
    }
}
